import React from 'react'
import { Box } from '@workwhile/ui'
import { DayforceWebhooksHeader } from './DayforceWebhooksHeader'
import { DayforceWebhooksFilterBar } from './DayforceWebhooksFilterBar'
import { DayforceWebhooksTable } from './DayforceWebhooksTable/DayforceWebhooksTable'

export const DayforceWebhooksMain = () => {
  return (
    <>
      <DayforceWebhooksHeader />
      <DayforceWebhooksFilterBar />
      <Box margin={3}>
        <DayforceWebhooksTable />
      </Box>
    </>
  )
}
